import { api_ } from '@shared/plugIn/axios';

export type GiftEventType = 'courtesy_view' | 'store_view' | 'item_view';

interface GiftEventLogDto {
  event: GiftEventType;
  bugo: string;
  giftItem?: string;
  sessionId: string;
}

export interface GiftEventLogItem {
  _id: string;
  event: GiftEventType;
  bugo: string;
  bugoBrand?: string;
  giftItem?: string;
  sessionId: string;
  createdAt: Date;
}

const getSessionId = (): string => {
  let id = sessionStorage.getItem('gift_sid');
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem('gift_sid', id);
  }
  return id;
};

export const trackGiftEvent = (
  event: GiftEventType,
  bugoId: string,
  giftItemId?: string,
) => {
  const dto: GiftEventLogDto = {
    event,
    bugo: bugoId,
    sessionId: getSessionId(),
  };
  if (giftItemId) dto.giftItem = giftItemId;

  api_.post('/public/gift-event-log', dto).catch((error) => {
    console.error('이벤트 로그 추적 실패:', error);
  });
};

export const getGiftEventLogList = async (
  startDate?: string,
  endDate?: string,
): Promise<GiftEventLogItem[]> => {
  const params: Record<string, string> = {};
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  const { data } = await api_.get<GiftEventLogItem[]>('/admin/gift-event-log', {
    params,
  });
  return data;
};
